export const getDataUrlForImageUrl = (url: string): Promise<string> => {
  const fileUrl = new URL(url, import.meta.url).href;
  return new Promise((resolve, reject) => {
    try {
      const img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        if (ctx) ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = (err) => reject('Failed to load image: ' + fileUrl);
      img.src = fileUrl;
    } catch (err) {
      reject(err);
    }
  });
};